export default __webpack_public_path__ + "static/media/login-img.733d4e5f.png";